import {
  MockMap,
  utils,
} from '@ama-sdk/core';
import {
  Contact,
  Email,
  Journey,
  JourneyElementCommon,
} from '@dapi/sdk';
import {
  AcceptanceRepository,
  BaggageRepository,
  combineBoardingPassResults,
  combineCheckInBaggagePolicies,
  combineJourneys,
  ContextualSeatmapDataRepository,
  createContact,
  createJourney,
  createJourneyTraveler,
  createMockData,
  createMockDataWithResponse,
  RecursivePartial,
  RegulatoryDetailsReplyDataRepository,
} from '@dapi/sdk/spec';

const email: Email = {
  address: 'christophe.bernard@amadeus.com',
  category: 'personal',
  contactType: 'Email',
  purpose: 'notification'
};

const journeyTemplate: RecursivePartial<Journey> = {
  contacts: [email],
  travelers: [
    createJourneyTraveler({
      template: {
        dateOfBirth: new utils.Date('1988-06-30'),
        gender: 'male',
        names: [
          {
            firstName: 'TEST',
            lastName: 'BERNARD',
            title: 'MR'
          }
        ]
      }
    })
  ]
};

const journeys = combineJourneys([journeyTemplate]).items;
const journeyElementIds = journeys[0].journeyElements.map((je: JourneyElementCommon) => je.id);

/**
 * FullCheckin mock
 * 1ADT
 * No baggage
 */
export const fullCheckin: MockMap = {
  generateBoardingPasses: [createMockDataWithResponse(combineBoardingPassResults(undefined, {
    journeyElementIds
  }).items, 201)],
  getBaggagePoliciesFromJourney: [createMockData(combineCheckInBaggagePolicies().items)],
  getJourneyUnpaidItems: [createMockDataWithResponse(undefined, 404, [{
    code: '10000',
    title: 'No unpaid service',
    type: 'error',
    id: '10000'
  }])],
  getRegulatoryDetails: [createMockData(RegulatoryDetailsReplyDataRepository.DEFAULT)],
  requestAcceptanceOfJourney: [createMockDataWithResponse(AcceptanceRepository.TWO_SECURITY_QUESTIONS, 201), createMockDataWithResponse(AcceptanceRepository.ACCEPTED, 201)],
  retrieveJourneyBaggages: [createMockData([BaggageRepository.DEFAULT])],
  retrieveJourneys: [createMockDataWithResponse(journeys, 201)],
  retrieveJourney: [
    createMockData(
      createJourney({
        template: {
          ...journeys[0],
          acceptance: AcceptanceRepository.ACCEPTED
        }
      })
    )
  ],
  retrieveSeatMapsJourneyDriven: [createMockData(ContextualSeatmapDataRepository.DEFAULT)]
};

const journeysWithMultipleTravelersTemplate: RecursivePartial<Journey> = {
  contacts: [email],
  travelers: [
    createJourneyTraveler({
      template: {
        dateOfBirth: new utils.Date('1988-06-30'),
        gender: 'male',
        names: [
          {
            firstName: 'JOHN',
            lastName: 'SMITH',
            title: 'MR'
          }
        ]
      }
    }),
    createJourneyTraveler({
      template: {
        dateOfBirth: new utils.Date('1990-06-30'),
        gender: 'female',
        names: [
          {
            firstName: 'VALERIE',
            lastName: 'SMITH',
            title: 'MR'
          }
        ]
      }
    }),
    createJourneyTraveler({
      template: {
        dateOfBirth: new utils.Date('1995-01-30'),
        gender: 'male',
        names: [
          {
            firstName: 'ANTHONY',
            lastName: 'SMITH',
            title: 'MR'
          }
        ]
      }
    })
  ]
};

const journeysWithMultipleTravelers = combineJourneys([journeysWithMultipleTravelersTemplate]).items;

/**
 * FullCheckin mock
 * 1ADT
 * With baggage
 */
export const fullCheckinWithBagsHPBTFailure: MockMap = {
  ...fullCheckin,
  retrieveJourneys: [createMockDataWithResponse(journeysWithMultipleTravelers, 201)],
  retrieveJourney: [
    createMockData(
      createJourney({
        template: {
          ...journeysWithMultipleTravelers[0],
          acceptance: AcceptanceRepository.ACCEPTED,
          contacts: [
            journeysWithMultipleTravelers[0].contacts![0],
            createContact({
              template: {
                travelerIds: ['JOURNEY-TRAVELER-2-MOCK'],
                address: 'anthony.smith@test.com',
                purpose: 'standard'
              } as any as Contact
            })
          ]
        }
      })
    )
  ],
  retrieveJourneyBaggages: [
    createMockData([{
      ...BaggageRepository.DEFAULT,
      travelerIds: [{
        id: 'JOURNEY-TRAVELER-0-MOCK'
      }, {
        id: 'JOURNEY-TRAVELER-2-MOCK'
      }],
      bagTagDeliveryEligibility: {
        status: 'eligible'
      }
    }])
  ]
};

export const fullCheckinWithBags: MockMap = {
  ...fullCheckinWithBagsHPBTFailure,
  requestBagTagDeliveries: [
    createMockDataWithResponse({
      emailDeliveryStatus: 'sent',
      documentEnvelopes: [
        {
          payload: 'payload content',
          metadata: {
            documentType: 'application/pdf',
            name: 'BagTags.pdf'
          }
        }
      ]
    }, 201)
  ]
};
